import { ItemHiddenState } from './item_hidden_state.js';

export enum ItemHiddenStateOnMenu {
  Shown = ItemHiddenState.Shown,
  HiddenIndefinitely = ItemHiddenState.HiddenIndefinitely,
  HiddenUntilTomorrow = ItemHiddenState.HiddenUntilTomorrow,
  ShownButUnavailable = 3,
}
